import RiskLevelCharts from "../../../../components/risk-level-charts.jsx";

export default function RegisteredProgram({ data }) {
    const cards = data?.protectedCitizens?.cards;

    return (
        <RiskLevelCharts
            chartTitle="Cadastros por Programas"
            total={cards?.registrationsTotal ?? 0}
            activeTotal={cards?.activeRegistrations}
            appsActive={cards?.activeApps}
            riskLevels={data?.protectedCitizens?.registrationsByProgram}
            className="col-span-4"
        />
    )
}
